import { Plural, Trans } from "@lingui/macro";
import type React from "react";
import type { FunctionComponent } from "react";
import type { TableSelection } from "./DataTable";

export const TableSelectionNotice: FunctionComponent<
  React.PropsWithChildren<{ selection: TableSelection }>
> = ({ selection }) => {
  if (selection.meta.allSelected) {
    return (
      <div className="p-4 text-center bg-skyLight">
        <Plural
          value={selection.selected.size}
          one="All items are selected."
          few={
            <Trans>
              <strong>#</strong> items are selected.
            </Trans>
          }
          other={
            <Trans>
              <strong>#</strong> items are selected.
            </Trans>
          }
        />{" "}
        <button
          type="button"
          className="text-turquoiseDark"
          onClick={() => selection.clear()}
        >
          <Trans>Cancel selection</Trans>
        </button>
      </div>
    );
  }
  if (selection.selected.size > 0) {
    return (
      <div className="p-4 text-center bg-skyLight">
        <Plural
          value={selection.selected.size}
          one={
            <Trans>
              <strong>#</strong> item is selected.
            </Trans>
          }
          few={
            <Trans>
              <strong>#</strong> items are selected.
            </Trans>
          }
          other={
            <Trans>
              <strong>#</strong> items are selected.
            </Trans>
          }
        />{" "}
        <button
          type="button"
          className="text-turquoiseDark"
          onClick={() => selection.selectAll()}
        >
          <Plural
            value={selection.allIds.length}
            one="Select all items"
            few="Select # items"
            other="Select # items"
          />
        </button>
        {" | "}
        <button
          type="button"
          className="text-turquoiseDark"
          onClick={() => selection.clear()}
        >
          <Trans>Cancel selection</Trans>
        </button>
      </div>
    );
  }

  return null;
};
